export default __webpack_public_path__ + "bacf2042a2c690146ba45c2047464077.svg";